import React, { useMemo } from 'react';
import { Dropdown } from 'semantic-ui-react';
import DropdownInput from 'components/dropdown-input';
import InputWrap from './InputWrap';
import styles from './styles/Select.module.scss';
import { IFormFieldProps } from './common';

export interface ISelectProps extends IFormFieldProps {
  creatable?: boolean;
  search?: boolean;
  options: any[];
}

const Select = ({
  children,
  basic,
  label,
  labelAfter,
  description,
  className,
  inputClassName,
  labelClassName,
  leftIcon,
  rightIcon,
  error,
  info,
  options,
  placeholder,
  tooltip,
  onChange,
  scrollIntoView,
  value,
  ...inputProps
}: ISelectProps) => {
  const handleChange = (_, data) => {
    if (onChange) {
      const target = { name: data.name, value: data.value };
      onChange({ target });
    }
  };

  const DropdownComponent =
    inputProps?.creatable || inputProps?.search ? DropdownInput : Dropdown;

  // When option is a string/non-array, it means we are fetching it asynchronously
  // For the meantime, we default it to an empty array
  const dropdownOptions = useMemo(
    () => (Array.isArray(options) ? options : []),
    [options],
  );

  return (
    <InputWrap
      className={className}
      errorClassName={classnames(styles.error, basic && styles.basicError)}
      error={error}
      label={label}
      labelAfter={labelAfter}
      description={description}
      labelClassName={labelClassName}
      name={inputProps.name}
      rightIcon={rightIcon}
      tooltip={tooltip}
      info={info}
      scrollIntoView={scrollIntoView}
    >
      <DropdownComponent
        className={classnames(
          styles.dropdown,
          basic && styles.basic,
          (Array.isArray(value) ? value.length > 0 : value) && styles.hasValue,
          inputClassName,
        )}
        options={dropdownOptions}
        icon="chevron down"
        placeholder={placeholder || ''}
        {...inputProps}
        value={value}
        onChange={handleChange}
        scrolling={true}
      />
      {children}
    </InputWrap>
  );
};

export default Select;
